import { api } from './api.js';

$(document).ready(function () {

    $('body').on('click', '.activityReporting', function () {
        activity.report($(this).data());
    });

    // to use when the event is not propagated to the first handler (ex: popup-closer)
    $('.forceActivityReporting').click(function () {
        activity.report($(this).data());
    });
});

export const activity = {

    report: function (data) {
        //var topic = data.topic || 'unknownTopic';

        $.ajax({
            url: api.resources.saveActivity,
            type: 'POST',
            dataType: 'json',
            data: { data: JSON.stringify(data) },
            success: function (result) {
                console.log('success', result);
            },
            error: function (result) {
                console.log('fail', result);
            }

        });

        console.log('reporting');
    }

};